import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { OPageHeader } from './OPageHeader'
import { ALoader } from '@atoms/ALoader'

export const OPageWrapper = ({
  children,
  pageIllustration = null,
  isHeaderVisible = true,
  className,
  contentClassName = '',
  isLoading = false,
  heightGap = 56,
}) => {
  return (
    <div
      className={classnames('relative flex flex-col w-full min-h-screen bg-wildSand', {
        [className]: !!className,
        'h-full': isLoading,
      })}
    >
      <div className="absolute inset-0 overflow-hidden">{pageIllustration}</div>

      {isHeaderVisible && <OPageHeader />}

      <div
        className={classnames(
          'relative flex-1 h-full w-full mx-auto max-w-7xl py-3.5 lg:pt-5 px-3 sm:px-5 lg:px-8 text-codGray z-[1]',
          contentClassName
        )}
        style={{ height: `calc(100vh - ${heightGap}px)` }}
      >
        {isLoading ? <ALoader className="h-full" /> : children}
      </div>
    </div>
  )
}
OPageWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
